import { useCallback } from 'react';

import useCurrentClinic, { clinicAllowedActions } from '../../hooks/useCurrentClinic';
import useLoggedUser from '../../hooks/useLoggedUser';
import type { orgAllowedActions } from '../../hooks/useLoggedUser/types';
import type { IUsePermissionsService } from './types';

export const usePermissionsService = (): IUsePermissionsService => {
  const { clinic } = useCurrentClinic();
  const { organization } = useLoggedUser();

  const isActionAllowed = useCallback(
    (action: string | clinicAllowedActions) => {
      return (
        clinic?.allowedActions?.some(
          (actionAllowed) => actionAllowed === action || actionAllowed === '*',
        ) ?? false
      );
    },
    [clinic?.uuid],
  );

  const isActionAllowedInOrg = (action: string | orgAllowedActions) => {
    return (
      (organization?.allowedActions?.includes(action) ||
        organization?.allowedActions?.includes('*')) ??
      false
    );
  };
  return {
    isActionAllowed,
    isActionAllowedInOrg,
    isAdmin: () => {
      return isActionAllowed(clinicAllowedActions.modifyRole);
    },
    hasAdminAccess: () => {
      return organization?.adminAccess || clinic?.adminAccess || false;
    },
    isOrgAdmin: () => {
      return organization?.adminAccess === true;
    },
    isCurrentWorkspaceAdmin: () => {
      return clinic?.adminAccess === true;
    },
  };
};
